<template lang="pug">
  v-container.mt-2
      v-dialog(v-model='showCancelReasonDialog' max-width='400px')
        v-card
          v-card-title
            span.headline Razon de cancelacion
          v-card-text
            | {{selectedWithdraw.cancelMotive}}
          v-card-actions
            v-spacer
            v-btn(color='blue' text='' @click='showCancelReasonDialog = false') cerrar
      h2.mb-2 Lista de solicitudes de retiro
      v-progress-linear(v-if="loading" indeterminate="" color="primary")
      v-data-table.elevation-1(:headers="headers" :items="withdraws" :items-per-page="15"  max-width='800')
          template(v-slot:item.actions="{ item }")
            v-btn(v-on='on' text v-if="item.status === 'cancelada'" icon='' color='blue' @click="openCancelReasonDialog(item)")
              v-icon mdi-eye
</template>

<script>
  import ReferralsCard from '@/components/custom/ReferralsCard'

  export default {
    components: {
      ReferralsCard: ReferralsCard,
    },
    data () {
      return {
        headers: [
          // cambiarlos por los de la nueva tabla
          { text: '', value: 'empty' },
          { text: 'Fecha(dia/mes/año)', value: 'requestDay' },
          { text: 'Monto', value: 'amount' },
          { text: 'Estado de solicitud', value: 'status' },
          { text: 'Acciones', value: 'actions' },
        ],
        withdraws: [],
        showCancelReasonDialog: false,
        loading: false,
        selectedWithdraw: {},
      }
    },
    created () {
      this.loading = true
      const withdrawData = {
        userId: this.$store.state.users.user.uid,
        isAdmin: false,
      }
      this.$store.dispatch('referrals/getWithdrawRequests', withdrawData).then(res => {
        // console.log(res)
        this.loading = false
        if (res) {
          this.withdraws = res.reverse()
        }
      })
    },
    methods: {
      openCancelReasonDialog (withdraw) {
        this.showCancelReasonDialog = true
        this.selectedWithdraw = withdraw
      },
    },
  }
</script>
